import { ServiceAgreementV2 } from 'pco-product-service-internal-consumer';
import { useUpdateServiceAgreement } from '../../../../../hooks/queries/privateBanking';
import { useCloseProductOutcome } from './useCloseProductOutcome';

export const useCloseServiceAgreement = (serviceAgreement: ServiceAgreementV2, brUid: string) => {
  const { mutateAsync, isPending: isClosing } = useUpdateServiceAgreement();
  const { onClosed, onCloseFailed } = useCloseProductOutcome(brUid, serviceAgreement.serviceAgreementId);

  const close = async () => {
    try {
      await mutateAsync({ serviceAgreement, brUid });
    } catch (error) {
      onCloseFailed(error);
      return;
    }
    onClosed();
  };

  return { close, isClosing };
};
